// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__fZijB","image404":"NotFound_image404__3f28K","homeBtn":"NotFound_homeBtn__3JOgX"};